import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';
import {
  types as actions,
  forgotPasswordCompletedAction,
  errorAction
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.FORGOT_PASSWORD),
    switchMap(action =>
      AuthService.forgotPassword(action.email).pipe(
        map(() => forgotPasswordCompletedAction(action.email)),
        catchError(error => of(errorAction(error)))
      )
    )
  );
}


// WEBPACK FOOTER //
// ./src/epics/auth/forgotPassword.js